/**
 * Theme Store - FutJá Admin Panel
 *
 * Gerenciamento centralizado do tema usando Zustand
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { darkTheme, lightTheme, getCSSVariables } from '../config/theme'

const useThemeStore = create(
	persist(
		(set, get) => ({
			// Estado
			theme: darkTheme,
			mode: 'dark',

			// Actions
			setTheme: (newTheme) => {
				set({ theme: newTheme, mode: newTheme.type })
				get().applyThemeToDOM(newTheme)
			},

			toggleTheme: () => {
				const currentMode = get().mode
				const newTheme = currentMode === 'light' ? darkTheme : lightTheme
				set({ theme: newTheme, mode: newTheme.type })
				get().applyThemeToDOM(newTheme)
			},

			initializeTheme: () => {
				const { mode } = get()
				const theme = mode === 'light' ? lightTheme : darkTheme
				set({ theme })
				get().applyThemeToDOM(theme)
			},

			// Aplica variáveis CSS do tema ao documento
			applyThemeToDOM: (theme) => {
				const root = document.documentElement
				const cssVariables = getCSSVariables(theme)

				Object.entries(cssVariables).forEach(([key, value]) => {
					root.style.setProperty(key, value)
				})

				// Adiciona classe do tema ao body
				document.body.classList.remove('theme-light', 'theme-dark')
				document.body.classList.add(`theme-${theme.type}`)
			},

			// Getters de conveniência
			isDark: () => get().mode === 'dark',
			isLight: () => get().mode === 'light',
			getColor: (colorKey) => get().theme.colors[colorKey],
		}),
		{
			name: 'futja-admin-theme',
			partialize: (state) => ({ mode: state.mode }),
		}
	)
)

export { useThemeStore }
export default useThemeStore
